module.exports = require("core-js/library/fn/number/is-nan");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/number/is-nan.js
// module id = 663
// module chunks = 0